import { injectable } from "inversify";
import {
  ILineSearchFilterParser,
  HttpLineSearchFilter,
  HttpLineSearchFilterOption,
} from "../../lineInfo/lineInfoRepository.types";
import {
  ILineSearchFilter,
  ILineSearchFilterOption,
} from "@/domain/entities/filter/filter.types";
import { Result, err, ok } from "neverthrow";
import { ParseError } from "@/repositories/shared/errors/parseError";

function parseCode(code: HttpLineSearchFilterOption): ILineSearchFilterOption {
  return {
    uid: code.uid,
    code: code.code,
    codeName: code.codeName,
  };
}

@injectable()
export class LineSearchFilterParser implements ILineSearchFilterParser {
  toDomain(
    filter: HttpLineSearchFilter
  ): Result<ILineSearchFilter, ParseError> {
    try {
      return ok({
        codeGroup: filter.codeGroup,
        codeGroupName: filter.codeGroupName,
        codes: filter.codes.map(parseCode),
      });
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
